import { useContext, useEffect, useState } from 'react'
import { DndContext, closestCenter } from '@dnd-kit/core'
import { SortableContext, arrayMove } from '@dnd-kit/sortable'
import * as React from 'react'
import {
  restrictToVerticalAxis,
  restrictToParentElement
} from '@dnd-kit/modifiers'
import { OpenCalendarDialog, SaveScheduleContext } from '@react-ui/context'
import SessionCardListDraggableItem from '@builder/react-ui/scheduler/session-card-list-draggable/session-card-list-draggable-item'

const SessionCardListDraggable = ({ isTraining, weekendSessions = 0 }) => {
  const { sessions, setTrainingSessions, setCourseSessions } =
    useContext(SaveScheduleContext)
  const setSessions = isTraining ? setTrainingSessions : setCourseSessions
  const items = isTraining ? sessions.training : sessions.course

  const [sessionBefore, setSessionBefore] = useState(null)
  const [sessionAfter, setSessionAfter] = useState(null)

  const [isDragging, setIsDragging] = useState(false)
  const [draggedSessionId, setDraggedSessionId] = useState(null)

  const resetDragging = () => {
    setIsDragging(false)
    setDraggedSessionId(null)
  }

  let indexCount: number = 1
  const handleDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) {
      return
    }
    let preventDnd = false

    const prevItems = [...items]
    const oldIndex = prevItems.findIndex((item) => item.id === active.id)
    const newIndex = prevItems.findIndex((item) => item.id === over.id)

    // Compute new order
    const newItems = arrayMove(prevItems, oldIndex, newIndex)

    // Get items before & after the moved item
    const beforeItem = newIndex > 0 ? newItems[newIndex - 1] : null
    const afterItem =
      newIndex < newItems.length - 1 ? newItems[newIndex + 1] : null

    // @ts-ignore
    if (afterItem && afterItem?.status === 'completed') {
      console.log('Movement prevented: Cannot move before a completed item.')
    } else {
      setSessionBefore(beforeItem)
      setSessionAfter(afterItem)
      setSessions(newItems)
    }

    if (!preventDnd) {
      setIsDragging(true)
      setDraggedSessionId(active.id)
    }
  }

  return (
    <OpenCalendarDialog.Provider
      value={{
        isDragged: isDragging,
        activeSessionId: draggedSessionId,
        resetDragging: resetDragging,
        sessionDateBefore: sessionBefore ? sessionBefore.date : '',
        sessionDateAfter: sessionAfter ? sessionAfter.date : ''
      }}
    >
      <DndContext
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
      >
        <SortableContext items={items.map((item) => item.id)}>
          <div className='flex flex-col gap-4 '>
            {items.map((session) => (
              <SessionCardListDraggableItem
                key={session.id}
                session={session}
                index={session.skipped ? null : indexCount++}
                weekendSessions={weekendSessions}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </OpenCalendarDialog.Provider>
  )
}

export default SessionCardListDraggable
